const env = process.env.REACT_APP_ENV || "production";
let url = "http://localhost:5000";

if(env === "production"){
   url = "https://budgetplus.herokuapp.com";
}
console.log("env",env)

export default {
  url,
  authorizationPath: "/auth",
};
